import React from 'react';

const Label = ({ htmlFor, required,  children }) => {
  return (
    <label
      className={required ? 'required-label' : ''}
      htmlFor={htmlFor}      
    >
      {children}
    </label>
  );
};

export default React.memo(Label);
